export default "__VITE_ASSET__DvRM6j5V__"